import React from 'react';

import { LinkBlockItemActive } from '@app/objects/LinkBlockItem';

// eslint-disable-next-line max-len
export const teleadviceMastheadText = 'This call was essential for my family and I to get on the same page with what Hershey was experiencing, and what the best decision was moving forward...[it] was invaluable to our decision making.';

export const teleadviceEmbedText = (
	<>
		<p>
			At this moment, you may be unsure of what the next move is or what the “right” thing to do is. You’ve probably read everything you can
			find online, watched videos, and written down what your veterinarian said at your last visit. If you feel like you need guidance, you’re
			not sure if you’re ready for euthanasia, or simply need to talk to someone about it, we’re here for you.
		</p>
	</>
);

export const teleadviceRichText1 = (
	<>
		<p>
			During a telehospice session, you will speak directly with a Lap of Love doctor over the phone or on Zoom for about 30 minutes. During
			your call, we'll go over many different ways your pet's quality of life can be addressed, ensuring you and your family leave your time
			with us confident about what the next step is.
		</p>
	</>
);

export const teleadviceRichText2 = (
	<>
		<ul>
			<li>Should my pet be taken to a veterinary or emergency clinic?</li>
			<li>What environmental changes can be made to make my pet more comfortable?</li>
			<li>How can I determine my pet's quality of life on my own?</li>
			<li> What happens to pets that experience this disease?</li>
			<li> How do I encourage normal behavior in my pet (e.g., eating or drinking)?</li>
			<li>When is the right time to consider euthanasia?</li>
			<li>How do I plan for euthanasia?</li>
			<li>How can I prepare for the loss of my pet?</li>
			<li>How can I get the help I need after my loss?</li>
		</ul>
	</>
);

export const disclaimer = (
	<>
		<p>
			*Disclaimer: Without conducting an in-person physical examination, our telehospice service cannot diagnose, treat, or prevent disease,
			illness, or pain. Our purpose is to provide general guidance for concerned pet parents.
		</p>
	</>
);

export const linkItems: Array<LinkBlockItemActive> = [
	{
		path: '/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
	},
	{
		path: '/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
	},
	{
		path: '/our-services/aftercare',
		name: 'Aftercare',
	},
	{
		path: '/our-services/telehospice',
		name: 'Telehospice',
		active: true,
	},
	{
		path: '/our-services/pet-loss-support',
		name: 'Pet Loss Support',
	},
];
